import { ModuleWithProviders, NgModule, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { extractSafeMappingBlocks, restoreSafeMappingBlocks, sanitizeHtmlContent } from './sanitize-html.util';

@Pipe({
    name: 'sanitizeHtml',
    standalone: false,
})
export class SanitizeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: any, mode?: string): SafeHtml {
        if (value == null) {
            return this.sanitizer.bypassSecurityTrustHtml('');
        }

        const stripped = sanitizeHtmlContent(String(value));
        const { html: protectedHtml, blocks } = extractSafeMappingBlocks(stripped);
        const angularSanitized = this.sanitizer.sanitize(SecurityContext.HTML, protectedHtml) ?? '';

        let html = angularSanitized;
        if (mode === 'anchorsOnly') {
            html = html.replace(/<a\b(?![^>]*\btarget=)([^>]*)>/gi, '<a target="_blank" rel="noopener noreferrer"$1>');
        } else {
            html = html.replace(/<a\b(?![^>]*\btarget=)/gi, '<a target="_blank" rel="noopener noreferrer" ');
        }

        html = restoreSafeMappingBlocks(html, blocks);
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}

@NgModule({
    declarations: [SanitizeHtmlPipe],
    exports: [SanitizeHtmlPipe],
})
export class PipesSanitizeHtmlPipeModule {
    public static forRoot(): ModuleWithProviders<PipesSanitizeHtmlPipeModule> {
        return {
            ngModule: PipesSanitizeHtmlPipeModule,
            providers: [SanitizeHtmlPipe],
        };
    }
}
